// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1d1zy","heart":"Footer_heart__2cBa3","pound":"Footer_pound__1Vr8e"};